var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:[
    'svg-icon',
    'svg-icon--' + _vm.icon,
    _vm.disabled ? `opacity-70 cursor-not-allowed` : '',
  ],on:{"click":function($event){!_vm.disabled ? _vm.$emit('click', $event) : null}}},[_c('use',{attrs:{"xlink:href":_vm.iconPath}})])
}
var staticRenderFns = []

export { render, staticRenderFns }